import { Component, OnDestroy, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DashboardService } from './dashboard.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AssessmentService } from '../assessment/assessment.service';
import { take } from 'rxjs/operators';

@Component( {
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: [ './dashboard.component.css' ]
} )
export class DashboardComponent implements OnInit, OnDestroy {
    cookieValue = '';
    cookieUsername = '';
    continueData = [];
    totalStep;
    currentStep;
    date;
    subtypeName;
    propertyAddress1;
    propertyAddress2;
    public showSpinner: boolean;
    isInprogress: boolean;
    isDataAvailable: boolean;
    score: any;
    subType;
    ViewResultdate;
    title;
    allAsmttypes: any;
    offsetheight: any;
    isFormValid: any;
    updat_msg: any;
    descoffsetht: any;
    prevdata: any;
    prevresults: any;

    config = {
        // autoplay: 1000, // Autoplay option having value in milliseconds
        initialSlide: 3, // Slide Index Starting from 0
        slidesPerView: 3, // Slides Visible in Single View Default is 1
        pagination: '.swiper-pagination', // Pagination Class defined
        paginationClickable: true, // Making pagination dots clicable
        nextButton: '.swiper-button-next', // Class for next button
        prevButton: '.swiper-button-prev', // Class for prev button
        spaceBetween: 5, // Space between each Item
        // loop: true
    };
    CreatePropertyForm = new FormGroup( {
        property: new FormControl( '', [ Validators.required ] ),
        property2: new FormControl(),
        applicant_type: new FormControl( '', [ Validators.required ] ),
        price: new FormControl()
    } );
    personClass = {
        'property': [
            { 'success-validate': false, 'error-validate': false },
            { 'icon-work-done': false, 'icon-close-border': false }
        ],
    };

    constructor( private cookieService: CookieService, private dashboardService: DashboardService,
        private router: Router, private assessmentService: AssessmentService ) {
    }

    ngOnInit() {
        this.prevresults = false;
        this.prevdata = false;
        this.cookieUsername = this.cookieService.get( 'username' );
        this.allAssessmentTypes();
        this.offsetheight = document.getElementById( 'h4title' ).offsetTop;
        this.descoffsetht = document.getElementsByTagName( 'h6' )[ 0 ].offsetTop;
        this.score = null;
    }

    allAssessmentTypes() {
        this.showSpinner = true;
        this.continueData = [];
        const continueData = [];
        this.allAsmttypes = [];
        this.assessmentService.getAssessmentContext().pipe( take( 1 ) )
            .subscribe( res => {
                this.allAsmttypes = res[ 'data' ];
                if ( this.allAsmttypes ) {
                    this.getViewResults();
                }

                res[ 'data' ].forEach( type => {
                    if ( type.assessment_type !== 'online security' ) {
                        this.dashboardService.getUserInfo( this.cookieService.get( 'userId' ), type.id ).pipe( take( 1 ) )
                            .subscribe( info => {
                                info[ 'property_address' ] = '';
                                let propertyaddress = '';

                                this.dashboardService.getPropertyInfo( info[ 'property_id' ],
                                    this.cookieService.get( 'userId' ) ).pipe( take( 1 ) )
                                    .subscribe( address => {
                                        propertyaddress = ( address[ 'address' ].address_line1
                                            && address[ 'address' ].address_line2 )
                                            ? address[ 'address' ].address_line1.concat( ', ' + address[ 'address' ].address_line2 )
                                            : address[ 'address' ].address_line1;
                                        info[ 'property_address' ] = propertyaddress;
                                    }, error => () => {
                                        this.showSpinner = false;
                                    } );

                                continueData.push( info );
                                this.showSpinner = false;

                            }, error => () => {
                                this.showSpinner = false;
                            } );
                    }
                } );
            }, error => () => {
                this.showSpinner = false;
            } );

        this.continueData = continueData;
        this.prevdata = ( this.continueData.length > 0 ) ? true : false
    }

    onContinuelastAssessment( prevData ) {
        this.cookieService.set( 'assessment_context_id', prevData.assessment_context_id );
        this.cookieService.set( 'assessment_type', prevData.assessment_type );
        this.cookieService.set( 'property_id', prevData.property_id );
        this.cookieService.set( 'property_address', prevData.property_address );
        this.cookieService.set( 'lastAssessmentContinue', 'true' );
        this.router.navigate( [ 'assessment/assessment-profile' ] );
    }

    onRetakeAssessment( retakeData ) {
        this.cookieService.set( 'assessment_context_id', retakeData.assessment_context_id );
        this.cookieService.set( 'assessment_type', retakeData.assessment_type );
        this.cookieService.set( 'property_id', retakeData.property_id );
        this.cookieService.set( 'property_address', retakeData.property_address );
        this.cookieService.set( 'lastAssessmentContinue', 'false' );
        this.router.navigate( [ 'assessment/assessment-profile' ] );
    }

    onStartAssessment() {
        this.cookieService.set( 'lastAssessmentContinue', 'false' );
        this.cookieService.delete( 'assessment_context_id' );
        this.cookieService.delete( 'property_address' );
        this.cookieService.delete( 'assessment_context_id' );
        this.cookieService.delete( 'property_id' );
        this.router.navigate( [ 'assessment/applicant-assessment' ] );
    }

    onEnterAddAddress() {
        if ( this.CreatePropertyForm.get( 'property' ).value.trim() !== '' ) {
            this.isFormValid = true;
            this.personClass[ 'property' ] = [
                { 'success-validate': true, 'error-validate': false },
                { 'icon-work-done': true, 'icon-close-border': false }
            ];
        } else {
            this.isFormValid = false;
            this.CreatePropertyForm.get( 'property' ).setValue( '' );
            this.personClass[ 'property' ] = [
                { 'success-validate': false, 'error-validate': true },
                { 'icon-work-done': false, 'icon-close-border': true }
            ];
        }
    }

    createProperty() {
        const newProperty = {
            'address': {
                'address_line1': this.CreatePropertyForm.get( 'property' ).value.trim(),
            },
            'property_type': this.CreatePropertyForm.get( 'applicant_type' ).value,
            'user_id': this.cookieService.get( 'userId' )
        };
        if ( this.CreatePropertyForm.get( 'property2' ).value ) {
            newProperty.address[ 'address_line2' ] = this.CreatePropertyForm.get( 'property2' ).value.trim();
        }
        if ( this.CreatePropertyForm.get( 'price' ).value ) {
            newProperty[ 'property_price' ] = parseInt( this.CreatePropertyForm.get( 'price' ).value );
        }
        this.dashboardService.createPropertyInfo( newProperty )
            .subscribe( post => {
                for ( const i in post ) {
                    if ( i === 'success_msg' ) {
                        this.updat_msg = post[ i ];
                    }
                }
                document.getElementById( 'property-popup1' ).click();
                this.CreatePropertyForm.reset();
            }
                , error => {
                    this.updat_msg = error.error.error_msg;
                } );
    }

    clearAdd() {
        this.CreatePropertyForm.reset();
        this.clearValidation();
    }

    clearValidation() {
        this.personClass = {
            'property': [
                { 'success-validate': false, 'error-validate': false },
                { 'icon-work-done': false, 'icon-close-border': false }
            ],
        };
        this.CreatePropertyForm.reset();
    }

    closePropertyPopUp() {
        if ( this.cookieService.check( 'property_id' ) ) {
            document.getElementById( 'property-popup-close' ).click();
            // this.router.navigate(['assessment/user-assessment']);
        }
    }

    timeStampToDate( timestamp ) {
        return new Date( timestamp );
    }

    getViewResults() {
        this.showSpinner = true;
        this.score = {};
        this.dashboardService.getlastfinalScore( this.cookieService.get( 'userId' ) ).pipe( take( 1 ) )
            .subscribe( scr => {
                this.score = scr;
                this.prevresults = true;
                this.score[ 'assessment_type' ] = '';
                const aid = this.score.assessment_context_id;
                this.allAsmttypes.forEach( asmt => {
                    if ( aid === asmt.id ) {
                        this.score[ 'assessment_type' ] = asmt.assessment_type;

                        this.score[ 'property_address' ] = '';
                        let propertyaddress = '';
                        this.dashboardService.getPropertyInfo( this.score[ 'property_id' ],
                            this.cookieService.get( 'userId' ) ).pipe( take( 1 ) )
                            .subscribe( address => {
                                propertyaddress = ( address[ 'address' ].address_line1 && address[ 'address' ].address_line2 )
                                    ? address[ 'address' ].address_line1.concat( ', ' + address[ 'address' ].address_line2 )
                                    : address[ 'address' ].address_line1;
                                this.score[ 'property_address' ] = propertyaddress;
                                this.showSpinner = false;
                            }, error => {
                                this.showSpinner = false;
                            } );
                    }
                } );
            }, error => {
                this.score = {};
                if ( error.status === 404 ) {
                    this.prevresults = false;
                    this.score = null;
                }
                this.showSpinner = false;
            } );

        // if (this.score === null) {
        //   this.prevresults = false;
        // } else { this.prevresults = true }

    }

    onViewResult( scr ) {
        this.cookieService.set( 'lastScore', 'true' );

        if ( this.cookieService.check( 'property_id' ) ) {
            this.cookieService.delete( 'property_id' );
            this.cookieService.set( 'property_id', scr.property_id );
        } else {
            this.cookieService.set( 'property_id', scr.property_id );
        }

        if ( this.cookieService.check( 'assessment_context_id' ) ) {
            this.cookieService.delete( 'assessment_context_id' );
            this.cookieService.set( 'assessment_context_id', scr.assessment_context_id );
        } else {
            this.cookieService.set( 'assessment_context_id', scr.assessment_context_id );
        }

        this.router.navigate( [ 'assessment/assessment-result' ] );
    }

    ngOnDestroy() {
        if ( document.getElementById( 'property-popup-close' ) ) {
            document.getElementById( 'property-popup-close' ).click();
        }
    }
}
